import React from 'react'
import Iframe from '../Iframe';

const Video = ({ videoSrcURL, videoTitle = "Video", ...props }) => (

    <div className="video">
        <Iframe
            src={videoSrcURL}
            title={videoTitle}
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            frameBorder="0"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            allowFullScreen
            width="420"
            height="400"
            style={{ marginTop: 20, marginBottom: 20, borderRadius: 10 }}

        />
    </div>
)

export default Video
